import {NgModule} from '@angular/core';
import {ModalMessageComponent} from "@app/shared/message/ModalMessageService";

@NgModule({
    declarations: [ModalMessageComponent],
    exports: [ModalMessageComponent],
    entryComponents: [
        ModalMessageComponent
        ]
})
export class ModalMessageModule {}
